import locale from 'live/init/global-locale'
const i18n = require('live/services/i18n')
const ptBr = require('./i18n/pt_br').default
const enUs = require('./i18n/en_us').default

const localeFiles = {
    pt_br: ptBr,
    en_us: enUs
}

i18n.add(localeFiles[locale])
